(() => {
  const desktop = window.matchMedia('(min-width: 769px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function initialize() {
    document.querySelectorAll('#SiteHeader .site-navigation > li > details').forEach((detail) => {
      const summary = detail.querySelector(':scope > summary');
      const panel = detail.querySelector(':scope > .site-nav__dropdown');
      if (!summary || !panel || summary.dataset.link !== '/collections/all' || detail.dataset.hellsinkiCatalogReady) return;
      detail.dataset.hellsinkiCatalogReady = 'true';
      detail.dataset.hover = 'false';
      detail.classList.add('hellsinki-catalog-menu');
      panel.classList.add('hellsinki-catalog-panel');
      let closeTimer;
      let animationTimer;
      const position = () => {
        const header = detail.closest('#SiteHeader');
        const bottom = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
        panel.style.setProperty('--hellsinki-menu-top', bottom + 'px');
      };
      const setOpen = (open) => {
        window.clearTimeout(closeTimer);
        if (!open && detail.classList.contains('is-closing') && desktop.matches) return;
        window.clearTimeout(animationTimer);
        if (open && desktop.matches) {
          document.querySelectorAll('#SiteHeader .site-nav__details[open]').forEach((other) => {
            if (other !== detail && !detail.contains(other)) other.open = false;
          });
          position();
          detail.classList.remove('is-closing');
          detail.open = true;
        } else if (detail.open && desktop.matches && !reducedMotion.matches) {
          detail.classList.add('is-closing');
          animationTimer = window.setTimeout(() => {
            detail.open = false;
            detail.classList.remove('is-closing');
            summary.setAttribute('aria-expanded', 'false');
          }, 220);
        } else {
          detail.classList.remove('is-closing');
          detail.open = false;
        }
        summary.setAttribute('aria-expanded', String(detail.open && !detail.classList.contains('is-closing')));
      };
      summary.addEventListener('click', (event) => {
        if (!desktop.matches) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        setOpen(event.detail === 0 ? !detail.open || detail.classList.contains('is-closing') : true);
      }, true);
      detail.addEventListener('pointerenter', (event) => {
        if (desktop.matches && event.pointerType !== 'touch') setOpen(true);
      });
      detail.addEventListener('pointerleave', (event) => {
        if (event.pointerType !== 'touch') closeTimer = window.setTimeout(() => setOpen(false), 140);
      });
      detail.addEventListener('focusout', () => {
        window.setTimeout(() => {
          if (!detail.contains(document.activeElement) && !detail.matches(':hover')) setOpen(false);
        }, 0);
      });
      detail.addEventListener('toggle', () => summary.setAttribute('aria-expanded', String(detail.open && !detail.classList.contains('is-closing'))));
      document.addEventListener('pointerdown', (event) => {
        if (detail.open && !detail.contains(event.target)) setOpen(false);
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && detail.open) {
          setOpen(false);
          summary.focus();
        }
      });
      window.addEventListener('scroll', position, { passive: true });
      window.addEventListener('resize', () => {
        if (desktop.matches) position();
        else setOpen(false);
      }, { passive: true });
      position();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
